module.exports = __webpack_public_path__ + "r-v3/img/ml_40_00_over.24cd756a.jpg";